<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Create Log Book">
      <v-card-actions>

        <v-btn absolute right top elevation="1" @click="$router.push({ name: 'logBookLists' })"
          :class="{ 'mt-4': $vuetify.breakpoint.xs, 'ml-4': $vuetify.breakpoint.smAndUp }"
          color="accent" type="submit">
          <v-icon left>mdi-arrow-left</v-icon>
          Back
        </v-btn>

      </v-card-actions>
      <v-card flat class="px-2">
        <form autocomplete="off">
          <v-row>
            <v-col cols="12" md="3">
              <label class="font-weight-medium body-2">Select academic year <span
                  class="error--text">*</span></label>
              <v-autocomplete class="my-0 py-1" v-model="academicYearID" :items="academicYearData"
                key="id" item-value="id" item-text="academicYear">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <label class="font-weight-medium body-2"> Select Class <span
                  class="error--text">*</span></label>
              <v-autocomplete class="my-0 py-1" placeholder="--Select--" name="classSelect" required
                v-model="selectedClassID" v-on:change="changeSections(), clearAll()" item-value="id"
                :items="classes" key="id" item-text="name">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="3">
              <label class="font-weight-medium body-2"> Select Section <span
                  class="error--text">*</span></label>

              <v-autocomplete class="my-0 py-1" placeholder="--Select--" v-on:change="clearAll()"
                name="sectionSelect" v-model="selectedSectionID" item-value="id"
                :items="classWiseSections" key="id" item-text="name" disabled >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <label class="font-weight-medium body-2">Date <span class="error--text">*</span>
              </label>

              <div class="control audit-date">
                <custom-date-picker @input="clearAll()" v-model="logDate" required :minToDate="minToDate"/>
                <!-- <input class="input" type="date" v-model="logDate" required :minToDate="minToDate"/> -->
              </div>
            </v-col>

          </v-row>

          <v-row>
            <v-col cols="12" md="12">
              <label class="font-weight-medium body-2">
                Contents
              </label>

              <div v-for="(n, i) of topics" :key="i">
                <v-card-component>
                  <br />
                  <v-row>
                    <v-col cols="12" md="11" class="pt-0 pb-0">
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-autocomplete label="Select Topic *" v-model.trim="topics[i].topicID"
                            clearable :items="topicLists" key="id" item-value="id" item-text="name">
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-textarea hide-details class="my-0 py-1" label="Content" clearable
                            clear-icon="mdi-close-circle" v-model.trim="topics[i].content" auto-grow
                            rows="3" row-height="25"></v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-textarea hide-details class="my-0 py-1"
                            label="Resources Required/ Teaching Aids" clearable
                            clear-icon="mdi-close-circle" v-model.trim="topics[i].resourcesRequired"
                            auto-grow rows="3" row-height="25"></v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-textarea hide-details class="my-0 py-1" label="Teacher's Task"
                            clearable clear-icon="mdi-close-circle"
                            v-model.trim="topics[i].teacherTask" auto-grow rows="3" row-height="25">
                          </v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-textarea hide-details class="my-0 py-1" label="Parent Task" clearable
                            clear-icon="mdi-close-circle" v-model.trim="topics[i].parentTask"
                            auto-grow rows="3" row-height="25"></v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-textarea hide-details class="my-0 py-1"
                            label="Learning Outcomes to be observed" clearable
                            clear-icon="mdi-close-circle"
                            v-model.trim="topics[i].outcomeToBeObserved" auto-grow rows="3"
                            row-height="25"></v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-textarea hide-details class="my-0 py-1"
                            label="Learning Outcomes of the class" clearable
                            clear-icon="mdi-close-circle" v-model.trim="topics[i].outcomeofTheClass"
                            auto-grow rows="3" row-height="25"></v-textarea>
                        </v-col>
                        <v-col cols="12" md="12">
                          <v-textarea hide-details class="my-0 py-1" label="Further Steps Planned"
                            clearable clear-icon="mdi-close-circle"
                            v-model.trim="topics[i].furtherStepsPlanned" auto-grow rows="3"
                            row-height="25">
                          </v-textarea>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="1" class="d-flex pt-0 pb-0 flex-column align-center">
                      <label class="font-weight-medium body-2">No. {{ i + 1 }}</label>

                      <v-card-actions>
                        <v-btn title="Delete parameter" elevation="1" color="error"
                          @click="deleteRow(i, topics[i])">
                          <v-icon left> mdi-trash-can </v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                  <br />
                </v-card-component>
              </div>

            </v-col>

            <v-col cols="12">
              <v-card-actions class="d-flex justify-end">
                <v-btn bottom right elevation="1" color="primary" @click="
                    topics.push({
                      topicID: '',
                      content: '',
                      resourcesRequired: '',
                      teacherTask: '',
                      parentTask: '',
                      outcomeToBeObserved: '',
                      outcomeofTheClass: '',
                      furtherStepsPlanned: '',
                      isActive: true
                    })
                  ">
                  <v-icon left> mdi-plus </v-icon>
                  Add Topics
                </v-btn>
                <v-btn bottom right elevation="1" color="primary" @click="saveAsDraftLog">
                  <v-icon left> mdi-content-save </v-icon>
                  Save Draft
                </v-btn>
                <v-btn bottom right elevation="1" color="primary" @click="submitLog">
                  Submit
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </form>
      </v-card>

    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import moment from 'moment'
import { mapGetters } from 'vuex'
import Utils from '@/utils'
import stores from '@/stores'
import _ from 'lodash'

export default {
  name: 'addLogBookEntry',
  components: {
    MaterialCard,
    CustomDatePicker,
    VCardComponent
  },
  data () {
    // const today = new Date()
    return {
      modules: {
        ViewLogbook: this.checkModuleAccess('ViewLogbook')
      },
      academicYearData: [],
      academicYearID: '',
      topicLists: [],
      topicID: '',
      // date: moment().format('DD-MM-YYYY'),
      logDate: moment().format('YYYY-MM-DD'),
      franchiseeID: '',
      franchiseeArr: [],
      user: stores.user.me,
      teacherID: stores.user.me.id,
      topics: [
        {
          topicID: '',
          content: '',
          resourcesRequired: '',
          teacherTask: '',
          parentTask: '',
          outcomeToBeObserved: '',
          outcomeofTheClass: '',
          furtherStepsPlanned: '',
          isActive: true
        }
      ],

      classSection: '',
      classSectionArray: [],
      selectedClassSectionArray: [],

      academicYears: [],
      selectedClassID: '',
      selectedSectionID: '',
      classWiseSections: [],
      classes: [],
      sections: [],
      studentArray: [],
      hasClicked: false,
      loader: true,
      minToDate: new Date().toISOString().slice(0, 10),
      // minToDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()).toISOString().slice(0, 10),
      isLoading: false,
      isWrite: false
    }
  },

  async created () {
    await this.getTopicList()
    await this.getAcademicYearsList()
    await this.onFranchiseeChange()
    // console.log(stores.user, 'users')
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
    // selectedClassID () {
    //   this.selectedSectionID = ''
    // }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    getAcademicYearsList: async function () {
      let rows = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`, {
        params: {
          isCurrentAcademicYear: true
        }
      })
      this.academicYearData = rows.data.rows
      this.academicYearID = this.academicYearData[1] ? this.academicYearData[1].id : ''
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (this.franchiseeID && this.academicYearID) {
          await this.getClassList()
        }
        this.clearAll()
        this.resetAll()
        this.inProgress = false
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&isAllValue=true`)
        if (data) {
          this.classes = data
          this.sections = data
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        console.log('errorMessage', errorMessage)
      }
    },
    changeSections: async function () {
      try {
        this.isLoading = true
        this.classWiseSections = []
        this.selectedSectionID = ''
        let searchIndex = this.classes.map(a => a.id).indexOf(this.selectedClassID)
        if (searchIndex > -1) {
          this.classWiseSections = this.classes[searchIndex].studentSections
          if (this.classWiseSections.length > 0) {
            this.selectedSectionID = this.classWiseSections[0]?.id || ''
          }
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },

    getTopicList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/log-book/getall-topic`)
        this.topicLists = res.data.rows
        this.topicID = this.topicLists.id
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    deleteRow (e, item) {
      if (item.id) {
        this.deleteParameters.push(item.id)
      }
      if (this.topics.length > 1) {
        this.topics = _.filter(this.topics, (a, b) => b !== e)
      } else {
        this.errMsg('Cannot delete! Atleast one content is required!')
      }
    },
    submitLog: async function () {
      try {
        if (!this.academicYearID) {
          this.errMsg('Please select a Year')
          return false
        } else if (!this.franchiseeID) {
          this.errMsg('Please select Franchisee')
          return false
        } else if (!this.selectedClassID) {
          this.errMsg('Please select Class')
          return false
        } else if (!this.selectedSectionID) {
          this.errMsg('Please select a Section.')
          return false
        }
        for (let item of this.topics) {
          if (item.topicID === '') {
            return this.errMsg('Please select a topic')
          }
        }
        let formData = {
          academicYearID: this.academicYearID,
          franchiseeID: this.franchiseeID,
          classID: this.selectedClassID,
          sectionID: this.selectedSectionID,
          Date: this.logDate,
          isPublish: true,
          isActive: true,
          topics: this.topics
        }
        let res = await http.post(`${constants.API_URL}/api/log-book/create`, formData)
        this.okMsg(res.data)
        this.$router.push({ name: 'logBookLists' })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    saveAsDraftLog: async function () {
      try {
        if (!this.academicYearID) {
          this.errMsg('Please select a Year')
          return false
        } else if (!this.franchiseeID) {
          this.errMsg('Please select Franchisee')
          return false
        } else if (!this.selectedClassID) {
          this.errMsg('Please select Class')
          return false
        } else if (!this.selectedSectionID) {
          this.errMsg('Please select a Section.')
          return false
        }
        for (let item of this.topics) {
          if (item.topicID === '') {
            return this.errMsg('Please Select a topic')
          }
        }
        let formData = {
          academicYearID: this.academicYearID,
          franchiseeID: this.franchiseeID,
          classID: this.selectedClassID,
          sectionID: this.selectedSectionID,
          Date: this.logDate,
          isPublish: false,
          isActive: true,
          topics: this.topics
        }
        let res = await http.post(`${constants.API_URL}/api/log-book/create`, formData)
        this.okMsg(res.data)
        this.$router.push({ name: 'logBookLists' })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    clearAll: async function () {
      this.generalDiary = []
      this.temp = ''
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    resetAll: async function () {
      //   this.fromDate = ''
      //   this.toDate = ''
      // this.selectedClassID = ''
      // this.selectedSectionID = ''
    }
  }
}
</script>
<style>
.addLogBtn {
  margin-left: 30px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
